// eslint-disable-next-line import/prefer-default-export
export const operatingSystems = [
  {
    name: 'ios',
    device: 'iPhone',
  },
  {
    name: 'ipados',
    device: 'iPad',
  },
  {
    name: 'tvos',
    device: 'Apple TV',
  },
  {
    name: 'macos',
    device: 'Mac',
  },
  {
    name: 'watchos',
    device: 'Apple Watch',
  },
  {
    name: 'visionos',
    device: 'Apple Vision',
  },
];
